import * as types from 'actions/autostart-tv/types';
import storage from 'helpers/storage';

const autostartTVData = JSON.parse(storage.get('autostartTVData'));

const data = {
  isAutostartTVEnabled: autostartTVData && autostartTVData.isAutostartTVEnabled ? true : false,
};

const initialState = {
  isLoading: false,
  data,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_AUTOSTART_TV:
      storage.set(
        'autostartTVData',
        JSON.stringify({ ...state.data, isAutostartTVEnabled: action.payload }),
      );
      return { ...state, data: { ...state.data, isAutostartTVEnabled: action.payload } };
    default:
      return state;
  }
};
